import { render, staticRenderFns } from "./ClaimApprovePopoutTabs.vue?vue&type=template&id=6f6517ab&"
import script from "./ClaimApprovePopoutTabs.vue?vue&type=script&lang=js&"
export * from "./ClaimApprovePopoutTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports